import { defineComponent as _defineComponent } from 'vue';
import Authenticated from './Authenticated.vue';
import CompanyMenu from '@/Components/Navigation/CompanyMenu.vue';
import { Head, Link } from '@inertiajs/inertia-vue3';
import CompanyAddActionsButton from '../Components/Navigation/CompanyAddActionsButton.vue';
import { computed } from 'vue';
import { usePageProps } from '../Plugins/page-props';
import FormPanels from '../Components/FormPanels.vue';
import DetailsPanels from '../Components/DetailsPanels.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Company',
    props: {
        title: String,
        subtitle: String,
        showCogIcon: {
            type: Boolean,
            default: true,
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const pageProps = usePageProps();
        const user = pageProps.user();
        const company = pageProps.company();
        const companyDetailsRoute = computed(() => (user.admin ? 'admin.companies.' : '') + 'company-details');
        const companyDetailsRouteData = computed(() => (user.admin ? company?.id : {}));
        let title = props.title ?? company?.name;
        let subtitle = props.subtitle;
        const headTitle = `${subtitle} - ${title}`;
        const __returned__ = { props, pageProps, user, company, companyDetailsRoute, companyDetailsRouteData, get title() { return title; }, set title(v) { title = v; }, get subtitle() { return subtitle; }, set subtitle(v) { subtitle = v; }, headTitle, Authenticated, CompanyMenu, get Head() { return Head; }, get Link() { return Link; }, CompanyAddActionsButton, FormPanels, DetailsPanels };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
